<template>
    <form class="w-100" autocomplete="on" method="post" @submit.prevent="validateRegistration()" ref="registrationForm">
        <div class="row">
            <div class="col-sm-12 col-md-8">
                <div class="input-unit" data-validate="mail">
                    <input data-testing="mail-register" type="email" name="email" autocomplete="email"
                        :id="'email' + _uid" v-model="username" data-autofocus>
                    <label :for="'email' + _uid">{{ $translate("Ceres::Template.regEmail") }}*</label>
                </div>
            </div>

            <div class="col-sm-6" v-if="!guestMode">
                <div class="input-unit d-flex align-items-center" :class="{ 'no-bottom media-xs-d': modalElement }" data-validate="password"
                    ref="passwordInput">
                    <input data-testing="password-register" :type="showPassword ? 'text' : 'password'" name="password" autocomplete="new-password"
                        :id="'new-password-' + _uid" v-model="password">
                    <label :for="'new-password-' + _uid">{{ $translate("Ceres::Template.regPassword") }}*</label>
                    <span @click="togglePasswordVisibility('password')" style="cursor: pointer; margin-right: 0.5rem;">
                        <svg v-if="!showPassword" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" style="height: 1rem; width: auto; fill: #999;">
                            <path d="M288 80c-65.2 0-118.8 29.6-159.9 67.7C89.6 183.5 63 226 49.4 256c13.6 30 40.2 72.5 78.6 108.3C169.2 402.4 222.8 432 288 432s118.8-29.6 159.9-67.7C486.4 328.5 513 286 526.6 256c-13.6-30-40.2-72.5-78.6-108.3C406.8 109.6 353.2 80 288 80zM95.4 112.6C142.5 68.8 207.2 32 288 32s145.5 36.8 192.6 80.6c46.8 43.5 78.1 95.4 93 131.1c3.3 7.9 3.3 16.7 0 24.6c-14.9 35.7-46.2 87.7-93 131.1C433.5 443.2 368.8 480 288 480s-145.5-36.8-192.6-80.6C48.6 356 17.3 304 2.5 268.3c-3.3-7.9-3.3-16.7 0-24.6C17.3 208 48.6 156 95.4 112.6zM288 336c44.2 0 80-35.8 80-80s-35.8-80-80-80c-.7 0-1.3 0-2 0c1.3 5.1 2 10.5 2 16c0 35.3-28.7 64-64 64c-5.5 0-10.9-.7-16-2c0 .7 0 1.3 0 2c0 44.2 35.8 80 80 80zm0-208a128 128 0 1 1 0 256 128 128 0 1 1 0-256z"/>
                        </svg>
                        <svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" style="height: 1rem; width: auto; fill: #999;">
                            <path d="M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zm151 118.3C226 97.7 269.5 80 320 80c65.2 0 118.8 29.6 159.9 67.7C518.4 183.5 545 226 558.6 256c-12.6 28-36.6 66.8-70.9 100.9l-53.8-42.2c9.1-17.6 14.2-37.5 14.2-58.7c0-70.7-57.3-128-128-128c-32.2 0-61.7 11.9-84.2 31.5l-46.1-36.1zM394.9 284.2l-81.5-63.9c4.2-8.5 6.6-18.2 6.6-28.3c0-5.5-.7-10.9-2-16c.7 0 1.3 0 2 0c44.2 0 80 35.8 80 80c0 9.9-1.8 19.4-5.1 28.2zm9.4 130.3C378.8 425.4 350.7 432 320 432c-65.2 0-118.8-29.6-159.9-67.7C121.6 328.5 95 286 81.4 256c8.3-18.4 21.5-41.5 39.4-64.8L83.1 161.5C60.3 191.2 44 220.8 34.5 243.7c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c47.8 0 89.9-12.9 126.2-32.5l-41.9-33zM192 256c0 70.7 57.3 128 128 128c13.3 0 26.1-2 38.2-5.8L302 334c-23.5-5.4-43.1-21.2-53.7-42.3l-56.1-44.2c-.2 2.8-.3 5.6-.3 8.5z"/>
                        </svg>
                    </span>
                </div>
            </div>

            <div class="col-sm-6 input-unit-group" v-if="!guestMode">
                <div class="input-unit d-flex align-items-center" :class="{ 'no-bottom': modalElement }" data-validate="ref">
                    <input :type="showPasswordRepeat ? 'text' : 'password'" name="password-repeat" autocomplete="new-password"
                        :id="'new-password-repeat-' + _uid" v-model="passwordRepeat"
                        :data-validate-ref="'#new-password-' + _uid" data-testing="repeat-password-register">
                    <label :for="'new-password-repeat-' + _uid">{{ $translate("Ceres::Template.regRepeatPassword")
                        }}*</label>
                    <span @click="togglePasswordVisibility('passwordRepeat')" style="cursor: pointer; margin-right: 0.5rem;">
                        <svg v-if="!showPasswordRepeat" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" style="height: 1rem; width: auto; fill: #999;">
                            <path d="M288 80c-65.2 0-118.8 29.6-159.9 67.7C89.6 183.5 63 226 49.4 256c13.6 30 40.2 72.5 78.6 108.3C169.2 402.4 222.8 432 288 432s118.8-29.6 159.9-67.7C486.4 328.5 513 286 526.6 256c-13.6-30-40.2-72.5-78.6-108.3C406.8 109.6 353.2 80 288 80zM95.4 112.6C142.5 68.8 207.2 32 288 32s145.5 36.8 192.6 80.6c46.8 43.5 78.1 95.4 93 131.1c3.3 7.9 3.3 16.7 0 24.6c-14.9 35.7-46.2 87.7-93 131.1C433.5 443.2 368.8 480 288 480s-145.5-36.8-192.6-80.6C48.6 356 17.3 304 2.5 268.3c-3.3-7.9-3.3-16.7 0-24.6C17.3 208 48.6 156 95.4 112.6zM288 336c44.2 0 80-35.8 80-80s-35.8-80-80-80c-.7 0-1.3 0-2 0c1.3 5.1 2 10.5 2 16c0 35.3-28.7 64-64 64c-5.5 0-10.9-.7-16-2c0 .7 0 1.3 0 2c0 44.2 35.8 80 80 80zm0-208a128 128 0 1 1 0 256 128 128 0 1 1 0-256z"/>
                        </svg>
                        <svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" style="height: 1rem; width: auto; fill: #999;">
                            <path d="M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zm151 118.3C226 97.7 269.5 80 320 80c65.2 0 118.8 29.6 159.9 67.7C518.4 183.5 545 226 558.6 256c-12.6 28-36.6 66.8-70.9 100.9l-53.8-42.2c9.1-17.6 14.2-37.5 14.2-58.7c0-70.7-57.3-128-128-128c-32.2 0-61.7 11.9-84.2 31.5l-46.1-36.1zM394.9 284.2l-81.5-63.9c4.2-8.5 6.6-18.2 6.6-28.3c0-5.5-.7-10.9-2-16c.7 0 1.3 0 2 0c44.2 0 80 35.8 80 80c0 9.9-1.8 19.4-5.1 28.2zm9.4 130.3C378.8 425.4 350.7 432 320 432c-65.2 0-118.8-29.6-159.9-67.7C121.6 328.5 95 286 81.4 256c8.3-18.4 21.5-41.5 39.4-64.8L83.1 161.5C60.3 191.2 44 220.8 34.5 243.7c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c47.8 0 89.9-12.9 126.2-32.5l-41.9-33zM192 256c0 70.7 57.3 128 128 128c13.3 0 26.1-2 38.2-5.8L302 334c-23.5-5.4-43.1-21.2-53.7-42.3l-56.1-44.2c-.2 2.8-.3 5.6-.3 8.5z"/>
                        </svg>
                    </span>
                </div>
            </div>

            <div v-if="!guestMode" class="col-12 mt-3">
                <ul class="fa-ul">
                    <li>
                        <i :class="['fa-li fa', { 'fa-times': !validPassLength, 'fa-check text-success': validPassLength }]"
                            aria-hidden="true"></i><!--
                            -->{{ $translate("Ceres::Template.regPasswordHintLength") }}
                    </li>
                    <li>
                        <i :class="['fa-li fa', { 'fa-times': !validPassDigit, 'fa-check text-success': validPassDigit }]"
                            aria-hidden="true"></i>
                        {{ $translate("Ceres::Template.regPasswordHintDigit") }}
                    </li>
                    <li>
                        <i :class="['fa-li fa', { 'fa-times': !validPassCharacter, 'fa-check text-success': validPassCharacter }]"
                            aria-hidden="true"></i>
                        {{ $translate("Ceres::Template.regPasswordHintChar") }}
                    </li>
                </ul>
            </div>

            <input class="honey" type="text" name="username" autocomplete="new-password" tabindex="-1"
                v-model="honeypot">

            <div class="col-12">
                <address-input-group template="#vue-address-input-group" v-if="!isSimpleRegistration" address-type="1"
                    :value="billingAddress" @input="setAddressDataField($event)" :optional-address-fields="shownFields"
                    :required-address-fields="requiredFields" :default-salutation="defaultSalutation">
                    <template #custom-address-fields>
                        <slot name="custom-address-fields"></slot>
                    </template>
                </address-input-group>
            </div>

            <div class="col-12" v-if="enableConfirmingPrivacyPolicy">
                <accept-privacy-policy-check class="mt-3 mb-0" v-model="privacyPolicyAccepted"
                    @input="privacyPolicyValueChanged($event)" :show-error="privacyPolicyShowError">
                </accept-privacy-policy-check>
            </div>
        </div>
        <div class="border-top mt-2 text-right">
            <slot name="extend-overlay-buttons"></slot>

            <button :disabled="isDisabled" class="btn btn-appearance btn-primary btn-medium mt-3"
                :class="buttonSizeClass" data-testing="register-submit">
                {{ $translate("Ceres::Template.regRegister") }}
                <icon icon="user-plus" class="default-float" :loading="isDisabled"></icon>
            </button>
        </div>

    </form>
</template>

<script>
import ValidationService from "../../services/ValidationService";
import { navigateTo } from "../../services/UrlService";
import { isNullOrUndefined, isDefined } from "../../helper/utils";
import { ButtonSizePropertyMixin } from "../../mixins/buttonSizeProperty.mixin";
import AddressInputGroup from "./AddressInputGroup.vue";
import ApiService from "../../services/ApiService";
import NotificationService from "../../services/NotificationService";
import ModalService from "../../services/ModalService";
import AcceptPrivacyPolicyCheck from "./AcceptPrivacyPolicyCheck.vue";

export default {

    name: "registration",

    components:
    {
        AddressInputGroup,
        AcceptPrivacyPolicyCheck
    },

    mixins: [ButtonSizePropertyMixin],

    props: {
        modalElement: String,
        guestMode: { type: Boolean, default: false },
        isSimpleRegistration: { type: Boolean, default: false },
        template: String,
        backlink: String,
        shownFields: Object,
        requiredFields: Object,
        defaultSalutation: {
            type: String,
            default: App.config.addresses.defaultSalutation
        }
    },

    data() {
        return {
            password: "",
            passwordRepeat: "",
            username: "",
            billingAddress: {
                countryId: null,
                stateId: null,
                gender: this.defaultSalutation
            },
            isDisabled: false,
            privacyPolicyAccepted: false,
            privacyPolicyShowError: false,
            enableConfirmingPrivacyPolicy: App.config.global.registrationRequirePrivacyPolicyConfirmation,
            modalShown: false,
            honeypot: "",
            validPassLength: false,
            validPassDigit: false,
            validPassCharacter: false,
            showPassword: false,
            showPasswordRepeat: false
        };
    },

    mounted() {
        this.$nextTick(() => {
            if (this.modalElement) {
                this.initModalEventListeners();
            }
        });
    },

    watch: {
        password() {
            this.validPassLength = this.password.length >= 8;
            this.validPassDigit = this.password.match(/\d/) !== null;
            this.validPassCharacter = this.password.match(/[a-zA-Z]/) !== null;
        }
    },

    methods: {
        validateRegistration() {
            ValidationService.validate(this.$refs.registrationForm)
                .done(() => {
                    if (!this.enableConfirmingPrivacyPolicy || this.privacyPolicyAccepted) {
                        this.sendRegistration();
                    }
                    else {
                        this.privacyPolicyShowError = true;
                        NotificationService.error(
                            this.$translate("Ceres::Template.contactAcceptFormPrivacyPolicy", { hyphen: "&shy;" })
                        );
                    }
                })
                .fail(invalidFields => {
                    if (!isNullOrUndefined(this.$refs.passwordHint) && invalidFields.indexOf(this.$refs.passwordInput) >= 0) {
                        this.$refs.passwordHint.showPopper();
                    }
                    const invalidFieldNames = this.getInvalidFieldNames(invalidFields);
                    if (invalidFieldNames.length > 0) {
                        NotificationService.error(
                            this.$translate("Ceres::Template.checkoutCheckAddressFormFields", { fields: invalidFieldNames.join(", ") })
                        );
                    }
                    ValidationService.markInvalidFields(invalidFields, "error");
                    if (this.enableConfirmingPrivacyPolicy && !this.privacyPolicyAccepted) {
                        this.privacyPolicyShowError = true;
                        NotificationService.error(
                            this.$translate("Ceres::Template.contactAcceptFormPrivacyPolicy", { hyphen: "&shy;" })
                        );
                    }
                });
        },
        getInvalidFieldNames(invalidFields = []) {
            const fieldNames = [];

            for (const field of invalidFields) {
                let fieldName = field.querySelector('label').innerHTML.trim();

                fieldName = fieldName.slice(-1) === "*" ? fieldName.slice(0, fieldName.length - 1) : fieldName;
                fieldNames.push(fieldName);
            }

            return fieldNames;
        },

        /**
         * Send the registration
         */
        sendRegistration() {
            const userObject = this.getUserObject();

            this.isDisabled = true;

            ApiService.post("/rest/io/customer", userObject)
                .done(response => {
                    ApiService.setToken(response);

                    if (!response.code) {
                        document.dispatchEvent(new CustomEvent("onSignUpSuccess", { detail: userObject }));

                        NotificationService.success(
                            this.$translate("Ceres::Template.regSuccessful")
                        ).closeAfter(3000);

                        if (document.getElementById(this.modalElement) !== null) {
                            ModalService.findModal(document.getElementById(this.modalElement)).hide();
                        }

                        if (this.backlink !== null && this.backlink) {
                            navigateTo(decodeURIComponent(this.backlink));
                        }
                        else {
                            location.reload();
                        }
                    }
                    else {
                        NotificationService.error(
                            this.$translate("Ceres::Template.regError")
                        ).closeAfter(10000);
                    }

                    this.isDisabled = false;
                })
                .fail((error) => {
                    NotificationService.error(error.error).closeAfter(10000);

                    this.isDisabled = false;
                });
        },

        setAddressDataField({ field, value }) {
            this.billingAddress[field] = value;
            this.billingAddress = Object.assign({}, this.billingAddress);
        },

        /**
         * Handle the user object which is send to the server
         * @returns {{contact: {referrerId: number, typeId: number, options: {typeId: {typeId: number, subTypeId: number, value: *, priority: number}}}, honeypot: string}|{contact: {referrerId: number, typeId: number, password: *, options: {typeId: {typeId: number, subTypeId: number, value: *, priority: number}}}, honeypot: string}}
         */
        getUserObject() {
            const userObject =
            {
                contact: {
                    referrerId: 1,
                    typeId: 1,
                    options: {
                        typeId: {
                            typeId: 2,
                            subTypeId: 4,
                            value: this.username,
                            priority: 0
                        }
                    }
                },
                honeypot: this.honeypot
            };

            if (!this.guestMode) {
                userObject.contact.password = this.password;
            }

            if (!this.isSimpleRegistration) {
                this.billingAddress.isPrimary = 1;
                userObject.billingAddress = this.billingAddress;
            }

            return userObject;
        },

        privacyPolicyValueChanged(value) {
            this.privacyPolicyAccepted = value;

            if (value) {
                this.privacyPolicyShowError = false;
            }
        },

        initModalEventListeners() {
            const modal = ModalService.findModal(document.getElementById(this.modalElement));

            if (isDefined(modal)) {
                modal.on("show.bs.modal",
                    () => {
                        this.modalShown = true;
                    });

                modal.on("hide.bs.modal",
                    () => {
                        this.modalShown = false;
                    });
            }
        },

        togglePasswordVisibility(field) {
            if (field === 'password') {
                this.showPassword = !this.showPassword;
            } else if (field === 'passwordRepeat') {
                this.showPasswordRepeat = !this.showPasswordRepeat;
            }
        }
    }
}
</script>
